import { render, staticRenderFns } from "./PresidentDashboard.vue?vue&type=template&id=7fe8ee58&scoped=true&"
import script from "./PresidentDashboard.vue?vue&type=script&lang=js&"
export * from "./PresidentDashboard.vue?vue&type=script&lang=js&"
import style0 from "./PresidentDashboard.vue?vue&type=style&index=0&id=7fe8ee58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe8ee58",
  null
  
)

export default component.exports